import * as base from 'store/bolt/header.js';
import Store from 'store/store';

Store.on('TOGGLE_SHARE_OPEN', () => {
	const shareOpen = Store.get()?.header?.shareOpen;
	if (shareOpen) {
		Store.emit('PLAY_SOUND', 'elevator');
	}
});

Store.on('CLICKED_MOBILE_NATIVE_SHARE', () => {
	Store.emit('PLAY_SOUND', 'elevator');
});

